/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycReportDto } from '../../models/kyc-report-dto';

export interface GetReport$Params {
  processId: string;
}

export function getReport(http: HttpClient, rootUrl: string, params: GetReport$Params, context?: HttpContext): Observable<StrictHttpResponse<KycReportDto>> {
  const rb = new RequestBuilder(rootUrl, getReport.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycReportDto>;
    })
  );
}

getReport.PATH = '/kyc/processes/{processId}/report';
